import Button from "@mui/material/Button"
import { ChangeEvent } from "react"
import Papa from "papaparse";

interface IProps {
    setCsvData: (data: Record<string, string>[]) => void
}

const decodeCsvFile = async (file: File): Promise<string> => {
    const buffer = await file.arrayBuffer();
    const bytes = new Uint8Array(buffer);

    // BOM UTF-16 (Excel) explicite.
    if (bytes.length >= 2 && bytes[0] === 0xff && bytes[1] === 0xfe) {
        return new TextDecoder("utf-16le").decode(bytes).replace(/^\uFEFF/, "");
    }
    if (bytes.length >= 2 && bytes[0] === 0xfe && bytes[1] === 0xff) {
        return new TextDecoder("utf-16be").decode(bytes).replace(/^\uFEFF/, "");
    }

    // Priorite UTF-8 strict.
    try {
        return new TextDecoder("utf-8", { fatal: true }).decode(bytes).replace(/^\uFEFF/, "");
    } catch {}

    // Fallbacks CSV ANSI/Excel: choisir le resultat le moins corrompu.
    const candidates = ["windows-1252", "iso-8859-1", "utf-8"] as const;
    let bestDecoded = "";
    let bestScore = Number.POSITIVE_INFINITY;

    for (const encoding of candidates) {
        try {
            const decoded = new TextDecoder(encoding).decode(bytes).replace(/^\uFEFF/, "");
            const replacementChars = (decoded.match(/\uFFFD/g) || []).length;
            const nullChars = (decoded.match(/\u0000/g) || []).length;
            const score = replacementChars * 100 + nullChars * 10;

            if (score < bestScore) {
                bestScore = score;
                bestDecoded = decoded;
            }
        } catch {
            // ignore unsupported encoding
        }
    }

    return bestDecoded;
}

const Component: React.FC<IProps> = ({setCsvData}) => {
    const onCsvLoad = async (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            const csvText = await decodeCsvFile(event.target.files[0]);

            Papa.parse<Record<string, string>>(csvText, {
                header: true,
                skipEmptyLines: true,
                delimiter: "",
                complete: (results) => setCsvData(results.data)  
            })
        }
    }

    return (
        <Button variant="outlined" color="inherit" sx={{color: 'rgb(68, 89, 110)'}}>
            <label htmlFor="logo">
                Charger le fichier csv
                <input id="logo" type="file" name="myImage" accept=".csv" style={{display: 'none', width: '100%'}} onChange={onCsvLoad} />
            </label>
        </Button>
    )
}

export default Component;